export const PHONE_VALIDATION = {
  PREFIXES: {
    PLUS: '+',
  },
  REGEX: {
    DIGITS_ONLY: /^\d{10,15}$/,
    UK: /^(\+44|0)?[1-9]\d{9,10}$/,
    INDIA: /^(\+91|0)?[6-9]\d{9}$/,
  },
  LENGTH: {
    MIN: 10,
    MAX: 15,
  },
  MESSAGES: {
    INVALID_PHONE: 'Invalid phone number (must be 10-15 digits)',
    INVALID_UK_PHONE: 'Invalid UK phone number',
    INVALID_INDIA_PHONE: 'Invalid Indian phone number (must start with 6-9)',
  },
  COUNTRY_CODES: {
    UK: '+44',
    INDIA: '+91',
  },
};

